enum BoxCardType {
    DEFAULT = 'default',
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
}

export default BoxCardType;